import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CourseItem from "../card/CourseItem";
import { useSelector } from 'react-redux';
import { convertISOToReadable } from "../../../../helpers/datetime_helper";

function ApprenticeshipCarousel({ apprenticeshipList }) {
  const ref = useRef(null);
  const imagePath  = useSelector((state) => state.user.paths.default_course);
  const settings = {
    margin: '10',
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2, 
          rows: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1368,
        settings: {
          slidesToShow: 2, 
          rows: 2,
          variableWidth: false,
        },
      }
    ],
  };

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };

  const courseData = apprenticeshipList?.map((course) => {
    return {
      className: "",
      courseImage: course?.program?.program_image_url ?? imagePath ?? '',
      courseTitle: course?.program?.program_name ?? 'Course',
      courseDeadline: `Deadline: ${course?.program?.expiry_date ? convertISOToReadable(course?.program?.expiry_date, 'short', false) : ''}`,
      courseDetailLink: course?.program?.launch_url ?? '',
    }
  }) ?? [];

  return (
    <>
      <Slider {...settings} ref={ref}>
        {courseData && courseData.map((course, index) => (
          <CourseItem key={index} {...course} />
        ))}
      </Slider>
    </>
  );
}

export default ApprenticeshipCarousel;
